/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import { Dropdown } from "primereact/dropdown"
import { MultiSelect } from "primereact/multiselect"
import { ListBox } from "primereact/listbox"
import CustomToolBar from "../../../ToolBar/customToolbar"
import {
  ratesTypes,
  mentalBotheredTypes,
  recivedMedicalCare,
  confirmationRefused,
  typeOfInsurance,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  nextForm,
  prevForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import MentalRow from "./MentalRow"
import { InputText } from "primereact/inputtext"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import {
  INTERVIEW_SECTIONS,
  INTERVIEW_TYPES,
} from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const Mental = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    interviewType,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [mental, setMental] = useState(interview[INTERVIEW_SECTIONS.MENTAL])
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.MENTAL &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.MENTAL
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const toast = useRef(null)

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.MENTAL, mental)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_MENTAL_DATA, {
          GpraF1: mental?.gpra_f_1,
          GpraF2a: mental?.gpra_f_2a,
          GpraF2aNum: mental?.gpra_f_2a_num,
          GpraF2b: mental?.gpra_f_2b,
          GpraF2bNum: mental?.gpra_f_2b_num,
          GpraF2c: mental?.gpra_f_2c,
          GpraF2cNum: mental?.gpra_f_2c_num,
          GpraF2d: mental?.gpra_f_2d,
          GpraF2dNum: mental?.gpra_f_2d_num,
          GpraF2e: mental?.gpra_f_2e,
          GpraF2eNum: mental?.gpra_f_2e_num,
          GpraF2f: mental?.gpra_f_2f,
          GpraF2fNum: mental?.gpra_f_2f_num,
          GpraF2g: mental?.gpra_f_2g,
          GpraF2gNum: mental?.gpra_f_2g_num,
          GpraF3: mental?.gpra_f_3,
          GpraF4a: mental?.gpra_f_4?.find(
            (i) => i === recivedMedicalCare[0].value
          ),
          GpraF4b: mental?.gpra_f_4?.find(
            (i) => i === recivedMedicalCare[1].value
          ),
          GpraF4c: mental?.gpra_f_4?.find(
            (i) => i === recivedMedicalCare[2].value
          ),
          GpraF4d: mental?.gpra_f_4?.find(
            (i) => i === recivedMedicalCare[3].value
          ),
          GpraF4e: mental?.gpra_f_4?.find(
            (i) => i === recivedMedicalCare[4].value
          ),
          GpraF4f: mental?.gpra_f_4?.find(
            (i) => i === recivedMedicalCare[5].value
          ),
          GpraF4f_a: mental?.gpra_f_4f_a,
          GpraF5: mental?.gpra_f_5,
          GpraF5a: mental?.gpra_f_5a,
          GpraF5a_a: mental?.gpra_f_5a_a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraFId: mental?.gpra_f_id,
          Additional: getAdditionalQuestions(mental),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.MENTAL, {
                ...mental,
                gpra_f_id: response.data.gpraFId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ mental: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (!mental?.gpra_f_1 && showQuestion(questions, "gpra_f_1")) {
      errors.gpra_f_1 = errorMessages.requiredMessage
    }
    if (mental?.gpra_f_2a_num===null) {
      errors.gpra_f_2a = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_2b_num===null) {
      errors.gpra_f_2b = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_2c_num===null) {
      errors.gpra_f_2c = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_2d_num===null) {
      errors.gpra_f_2d = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_2e_num===null) {
      errors.gpra_f_2e = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_2f_num===null) {
      errors.gpra_f_2f = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_2g_num===null) {
      errors.gpra_f_2g = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_3 && showQuestion(questions, "gpra_f_3")) {
      errors.gpra_f_3 = errorMessages.requiredMessage
    }
    if (mental?.gpra_f_4?.length === 0 && showQuestion(questions, "gpra_f_4")) {
      errors.gpra_f_4 = errorMessages.requiredMessage
    } else if (
      mental?.gpra_f_4?.find((i) => i === recivedMedicalCare[5].value) &&
      !mental?.gpra_f_4f_a) {
      errors.gpra_f_4f_a = errorMessages.requiredMessage
    }
    if (!mental?.gpra_f_5 && showQuestion(questions, "gpra_f_5")) {
      errors.gpra_f_5 = errorMessages.requiredMessage
    } else if (
      mental?.gpra_f_5 === "Yes" &&
      !mental?.gpra_f_5a &&
      showQuestion(questions, "gpra_f_5")
    ) {
      errors.gpra_f_5a = errorMessages.requiredMessage
    } else if (
      mental?.gpra_f_5a === "Other" &&
      !mental?.gpra_f_5a_a &&
      showQuestion(questions, "gpra_f_5")
    ) {
      errors.gpra_f_5a_a = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        mental,
        INTERVIEW_SECTIONS.MENTAL,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }
  const renderDefaultMain = (question) => {
    if (question.field === "gpra_f_1") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. How would you rate your quality of life over the past 30 days?`}
            required
          />
          <Dropdown
            disabled={disabled}
            showClear={mental?.gpra_f_1}
            className={
              validationErrors.gpra_f_1
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
            value={mental?.gpra_f_1}
            onChange={(e) => {
              updateState(
                "gpra_f_1",
                e.value,
                null,
                null,
                mental,
                setMental,
                null
              )
              removeError("gpra_f_1")
            }}
            options={ratesTypes}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_f_1} />
        </div>
      )
    }
    if (question.field === "gpra_f_2") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. In the past 30 days, how many days have you [ENTER ‘0’ IN DAYS FOR NO RESPONSE]`}
            />
            <MentalRow
              entity={mental}
              setEntity={setMental}
              disabled={disabled}
              num={mental?.gpra_f_2a_num}
              setNum={"gpra_f_2a_num"}
              refused={mental?.gpra_f_2a}
              setRefused={"gpra_f_2a"}
              legend="a. Experienced serious depression"
              numError={validationErrors.gpra_f_2a}
              removeError={removeError}
              numErrorType="gpra_f_2a"
              defaultZero={question.defaultZero}
              required
            />
            <div className={gpraStyles.formRow}>
              <MentalRow
                entity={mental}
                setEntity={setMental}
                disabled={disabled}
                num={mental?.gpra_f_2b_num}
                setNum={"gpra_f_2b_num"}
                refused={mental?.gpra_f_2b}
                setRefused={"gpra_f_2b"}
                legend="b. Experienced serious anxiety or tension"
                numError={validationErrors.gpra_f_2b}
                removeError={removeError}
                numErrorType="gpra_f_2b"
                defaultZero={question.defaultZero}
                required
              />
            </div>
            <div className={gpraStyles.formRow}>
              <MentalRow
                entity={mental}
                setEntity={setMental}
                disabled={disabled}
                num={mental?.gpra_f_2c_num}
                setNum={"gpra_f_2c_num"}
                refused={mental?.gpra_f_2c}
                setRefused={"gpra_f_2c"}
                legend="c. Experienced hallucinations"
                numError={validationErrors.gpra_f_2c}
                removeError={removeError}
                numErrorType="gpra_f_2c"
                defaultZero={question.defaultZero}
                required
              />
            </div>
            <div className={gpraStyles.formRow}>
              <MentalRow
                entity={mental}
                setEntity={setMental}
                disabled={disabled}
                num={mental?.gpra_f_2d_num}
                setNum={"gpra_f_2d_num"}
                refused={mental?.gpra_f_2d}
                setRefused={"gpra_f_2d"}
                legend="d. Experienced trouble understanding, concentrating, or remembering"
                numError={validationErrors.gpra_f_2d}
                removeError={removeError}
                numErrorType="gpra_f_2d"
                defaultZero={question.defaultZero}
                required
              />
            </div>
            <div className={gpraStyles.formRow}>
              <MentalRow
                entity={mental}
                setEntity={setMental}
                disabled={disabled}
                num={mental?.gpra_f_2e_num}
                setNum={"gpra_f_2e_num"}
                refused={mental?.gpra_f_2e}
                setRefused={"gpra_f_2e"}
                legend="e. Experienced trouble controlling violent behavior"
                numError={validationErrors.gpra_f_2e}
                removeError={removeError}
                numErrorType="gpra_f_2e"
                defaultZero={question.defaultZero}
                required
              />
            </div>
            <div className={gpraStyles.formRow}>
              <MentalRow
                entity={mental}
                setEntity={setMental}
                disabled={disabled}
                num={mental?.gpra_f_2f_num}
                setNum={"gpra_f_2f_num"}
                refused={mental?.gpra_f_2f}
                setRefused={"gpra_f_2f"}
                legend="f. Attempted suicide"
                numError={validationErrors.gpra_f_2f}
                removeError={removeError}
                numErrorType="gpra_f_2f"
                required
              />
            </div>
            <div className={gpraStyles.formRow}>
              <MentalRow
                entity={mental}
                setEntity={setMental}
                disabled={disabled}
                num={mental?.gpra_f_2g_num}
                setNum={"gpra_f_2g_num"}
                refused={mental?.gpra_f_2g}
                setRefused={"gpra_f_2g"}
                legend="g. Been prescribed medication for psychological/emotional problem"
                numError={validationErrors.gpra_f_2g}
                removeError={removeError}
                numErrorType="gpra_f_2g"
                required
              />
            </div>
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "[IF CLIENT REPORTS 1 OR MORE DAY TO ANY QUESTION IN #2, PLEASE ENSURE THAT THEY ARE SEEN BY A LICENSED PROFESSIONAL AS SOON AS POSSIBLE.]"
              }
            />
          </div>
        </>
      )
    }
    if (question.field === "gpra_f_3") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. How much have you been bothered by these psychological or emotional problems in the past 30 days?`}
            required
          />
          <Dropdown
            value={mental?.gpra_f_3}
            onChange={(e) => {
              updateState(
                "gpra_f_3",
                e.value,
                null,
                null,
                mental,
                setMental,
                null
              )
              removeError("gpra_f_3")
            }}
            disabled={disabled}
            options={mentalBotheredTypes}
            optionLabel="label"
            optionValue="value"
            showClear={mental?.gpra_f_3}
            className={
              validationErrors.gpra_f_3
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
          />
          <FormError error={validationErrors.gpra_f_3} />
        </div>
      )
    }
    if (question.field === "gpra_f_4") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. In the past 30 days, where have you gone to receive medical care? You may select more than one response.`}
              required
            />
            {disabled ? (
              <ListBox
                disabled
                options={mental?.gpra_f_4}
                className={gpraStyles.input4}
              />
            ) : (
              <MultiSelect
                value={mental?.gpra_f_4}
                maxSelectedLabels={4}
                options={recivedMedicalCare}
                onChange={(e) => {
                  updateState(
                    "gpra_f_4",
                    e.value,
                    null,
                    null,
                    mental,
                    setMental,
                    null
                  )
                  removeError("gpra_f_4")
                }}
                optionLabel="label"
                optionValue="value"
                showSelectAll={false}
                showClear={mental?.gpra_f_4}
                disabled={disabled}
                className={ validationErrors.gpra_f_4 ? gpraStyles.input4Error : gpraStyles.input4}
              />
            )}

            <FormError error={validationErrors.gpra_f_4} />
          </div>
          {mental?.gpra_f_4?.find((i) => i === recivedMedicalCare[5].value) && (
            <div className={gpraStyles.formRow}>
              <FormLabel label={"Other (Specify)"} left={"1"} required/>
              <InputText
                disabled={
                  !mental?.gpra_f_4?.find(
                    (i) => i === recivedMedicalCare[5].value
                  ) || disabled
                }
                placeholder={
                  !mental?.gpra_f_4?.find(
                    (i) => i === recivedMedicalCare[5].value
                  )
                    ? "Not Applicable"
                    : ""
                }
                value={mental?.gpra_f_4f_a}
                onChange={(e) => {
                  updateState(
                    "gpra_f_4f_a",
                    e.target.value,
                    null,
                    null,
                    mental,
                    setMental,
                    null
                  )
                  removeError("gpra_f_4f_a")
                }}
                className={
                  validationErrors.gpra_f_4f_a
                    ? gpraStyles.inputText4Error
                    : gpraStyles.inputText4
                }
              />
              <FormError error={validationErrors.gpra_f_4f_a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_f_5") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Do you currently have medical/health insurance?`}
              required
            />
            <Dropdown
              value={mental?.gpra_f_5}
              onChange={(e) => {
                removeError("gpra_f_5")
                if (e.value !== "Yes") {
                  updateState(
                    "gpra_f_5",
                    e.value,
                    null,
                    null,
                    mental,
                    setMental,
                    [{ key: "gpra_f_5a", value: "" }]
                  )
                  removeError("gpra_f_5a_a")
                } else {
                  updateState(
                    "gpra_f_5",
                    e.value,
                    null,
                    null,
                    mental,
                    setMental,
                    null
                  )
                }
              }}
              disabled={disabled}
              options={confirmationRefused}
              optionLabel="label"
              optionValue="value"
              showClear={mental?.gpra_f_5}
              className={
                validationErrors.gpra_f_5
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
            />
            <FormError error={validationErrors.gpra_f_5} />
          </div>
          {mental?.gpra_f_5 === "Yes" && (
            <div className={gpraStyles.formRow}>
              <Dropdown
                value={mental?.gpra_f_5a}
                onChange={(e) => {
                  removeError("gpra_f_5a")
                  if (e.value !== "Other") {
                    updateState(
                      "gpra_f_5a",
                      e.value,
                      null,
                      null,
                      mental,
                      setMental,
                      [{ key: "gpra_f_5a_a", value: "" }]
                    )
                    removeError("gpra_f_5a_a")
                  } else {
                    updateState(
                      "gpra_f_5a",
                      e.value,
                      null,
                      null,
                      mental,
                      setMental,
                      null
                    )
                  }
                }}
                disabled={disabled || mental?.gpra_f_5 !== "Yes"}
                options={typeOfInsurance}
                optionLabel="label"
                optionValue="value"
                showClear={mental?.gpra_f_5a}
                className={
                  validationErrors.gpra_f_5a
                    ? gpraStyles.input4AuxError
                    : gpraStyles.input4Aux
                }
              />
              <FormError error={validationErrors.gpra_f_5a} errorType={2} />
            </div>
          )}
          {mental?.gpra_f_5 === "Yes" && mental?.gpra_f_5a === "Other" && (
            <div className={gpraStyles.formRow}>
              <InputText
                disabled={mental?.gpra_f_5a !== "Other" || disabled}
                placeholder={
                  mental?.gpra_f_5a !== "Other" ? "Not Applicable" : ""
                }
                value={mental?.gpra_f_5a_a}
                onChange={(e) => {
                  updateState(
                    "gpra_f_5a_a",
                    e.target.value,
                    null,
                    null,
                    mental,
                    setMental,
                    null
                  )
                  removeError("gpra_f_5a_a")
                }}
                className={
                  validationErrors.gpra_f_5a_a
                    ? gpraStyles.inputText5AuxError
                    : gpraStyles.inputText5Aux
                }
              />
              <FormError error={validationErrors.gpra_f_5a_a} />
            </div>
          )}
        </>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="F. MENTAL AND PHYSICAL HEALTH PROBLEMS AND TREATMENT/RECOVERY"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={mental}
                    setEntity={setMental}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.MENTAL}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, mental)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={mental}
                      setEntity={setMental}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.MENTAL}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

Mental.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}
Mental.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Mental
